import { useQuery } from "@tanstack/react-query";
import { HttpStatusCode } from "axios";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useUserJourney } from "@pages/journey-map/api/use-user-journey";

const DEFAULT_BUDGET_PLAN = {
  budgetTotals: { costs: 0, savings: 0 },
  taxInfo: { netIncome: 0 },
};

export const useBudgetPlanQueryOptions = () => {
  const { data: userJourney } = useUserJourney();
  const transfrId = userJourney?.currentJourneyCareer?.transfrId;

  const queryFn = useApiRequest({
    url: "users/me/budget-plan",
    method: HttpMethod.Get,
    params: {
      // Currently no need for this to ever be false
      include_options: true,
    },
  });

  return {
    queryKey: ["budget-plan", transfrId],
    queryFn: async () => {
      return await queryFn({}).catch((error) => {
        const { status } = error;
        if (status === HttpStatusCode.NotFound) {
          return {
            notFound: status,
            noBudgetPlan: true,
            ...DEFAULT_BUDGET_PLAN,
          };
        }

        throw error;
      });
    },
    placeholderData: {
      ...DEFAULT_BUDGET_PLAN,
    },
    select: (data) => {
      if (data === "") {
        return {
          ...DEFAULT_BUDGET_PLAN,
        };
      }

      if (data.taxInfo === null) {
        data.taxInfo = DEFAULT_BUDGET_PLAN.taxInfo;
      }

      return {
        ...data,
      };
    },
  };
};

export const useBudgetPlan = () => {
  return useQuery(useBudgetPlanQueryOptions());
};
